(() => {
  const initCollection = (root) => {
    if (!root || root.dataset.szCollectionReady === 'true') return;
    root.dataset.szCollectionReady = 'true';

    const setLoading = () => {
      root.classList.add('is-loading');
      root.querySelector('.sz-collection__results')?.setAttribute('aria-busy', 'true');
    };

    const sortSelect = root.querySelector('[data-sz-sort-select]');
    if (sortSelect) {
      sortSelect.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSelect.value);
        url.searchParams.delete('page');
        const results = root.querySelector('.sz-collection__results');
        if (results?.id) url.hash = results.id;
        setLoading();
        window.location.assign(url.toString());
      });
    }

    root.querySelectorAll('[data-sz-filter-form][data-sz-filter-mode="desktop"]').forEach((form) => {
      let timer;
      form.addEventListener('change', (event) => {
        const target = event.target;
        if (!target) return;
        if (target.matches('input[type="checkbox"], input[type="radio"], select')) {
          window.clearTimeout(timer);
          timer = window.setTimeout(() => {
            setLoading();
            form.requestSubmit();
          }, 140);
        }
      });
    });

    root.querySelectorAll('[data-sz-filter-form]').forEach((form) => {
      form.addEventListener('submit', () => root.classList.add('is-loading'));
    });

    const description = root.querySelector('[data-sz-collection-description]');
    const descriptionToggle = root.querySelector('[data-sz-description-toggle]');
    if (description && descriptionToggle) {
      descriptionToggle.addEventListener('click', () => {
        const collapsed = description.classList.toggle('is-collapsed');
        descriptionToggle.setAttribute('aria-expanded', String(!collapsed));
        const label = descriptionToggle.querySelector('[data-sz-description-label]');
        if (label) label.textContent = collapsed ? 'Read more' : 'Show less';
      });
    }

    const drawer = root.querySelector('[data-sz-filter-drawer]');
    const openButton = root.querySelector('[data-sz-filter-open]');
    const closeButtons = root.querySelectorAll('[data-sz-filter-close]');
    let lastFocused = null;

    const closeDrawer = () => {
      if (!drawer) return;
      root.classList.remove('is-filter-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('sz-filter-open');
      if (openButton) openButton.setAttribute('aria-expanded', 'false');
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    };

    const openDrawer = () => {
      if (!drawer) return;
      lastFocused = document.activeElement;
      root.classList.add('is-filter-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('sz-filter-open');
      if (openButton) openButton.setAttribute('aria-expanded', 'true');
      const close = drawer.querySelector('.sz-filter-drawer__close');
      if (close) window.setTimeout(() => close.focus(), 30);
    };

    if (openButton && drawer) openButton.addEventListener('click', openDrawer);
    closeButtons.forEach((button) => button.addEventListener('click', closeDrawer));

    const mobileFilterGroups = drawer ? Array.from(drawer.querySelectorAll('.sz-filter-group')) : [];
    mobileFilterGroups.forEach((detail) => {
      detail.addEventListener('toggle', () => {
        if (!detail.open) return;
        mobileFilterGroups.forEach((other) => {
          if (other !== detail) other.removeAttribute('open');
        });
      });
    });

    const topButton = document.createElement('button');
    topButton.type = 'button';
    topButton.className = 'sz-collection-top';
    topButton.setAttribute('aria-label', 'Back to top');
    topButton.innerHTML = '<span aria-hidden="true">↑</span><strong>Top</strong>';
    root.appendChild(topButton);

    const syncTopButton = () => {
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      const rect = root.getBoundingClientRect();
      const show = mobile && window.scrollY > 950 && rect.bottom > window.innerHeight * .45;
      topButton.classList.toggle('is-visible', show);
      topButton.tabIndex = show ? 0 : -1;
      topButton.setAttribute('aria-hidden', show ? 'false' : 'true');
    };

    topButton.addEventListener('click', () => {
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      root.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
    });

    const syncViewportState = () => {
      syncTopButton();
      if (window.matchMedia('(min-width: 990px)').matches && root.classList.contains('is-filter-open')) {
        closeDrawer();
      }
    };

    window.addEventListener('scroll', syncTopButton, { passive: true });
    window.addEventListener('resize', syncViewportState, { passive: true });
    syncViewportState();

    document.addEventListener('keydown', (event) => {
      if (!root.classList.contains('is-filter-open')) return;

      if (event.key === 'Escape') {
        closeDrawer();
        return;
      }

      if (event.key === 'Tab' && drawer) {
        const focusable = Array.from(drawer.querySelectorAll(
          'button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )).filter((element) => element.offsetParent !== null);

        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-sz-collection-section]').forEach(initCollection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();